var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoInvoicesRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 498,
    height: 201,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_1",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    x: 317.31573,
    y: -232.65119,
    id: "svg_2",
    fill: "#86AAB4",
    transform: "matrix(-0.922336 0.264475 0.264475 0.922336 530.292 289.445)",
    rx: 17.5922,
    height: 35.1845,
    width: 35.1845
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    x: 317.31573,
    y: -232.65119,
    id: "svg_3",
    fill: "#86AAB4",
    transform: "matrix(-0.922336 0.264475 0.264475 0.922336 386.654 224.827)",
    rx: 17.5922,
    height: 35.1845,
    width: 35.1845
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    x: 317.31573,
    y: -232.65119,
    id: "svg_4",
    fill: "#435E64",
    transform: "matrix(-0.922336 0.264475 0.264475 0.922336 716.814 130.66)",
    rx: 17.5,
    height: 35,
    width: 176
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    x: 317.31573,
    y: -232.65119,
    id: "svg_5",
    fill: "#5D7C84",
    transform: "matrix(-0.922336 0.264475 0.264475 0.922336 587.007 167.325)",
    rx: 17.5922,
    height: 35.1845,
    width: 180.32
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    x: 317.31573,
    y: -232.65119,
    id: "svg_6",
    fill: "#86AAB4",
    transform: "matrix(-0.922336 0.264475 0.264475 0.922336 587.007 167.325)",
    rx: 17.5922,
    height: 35.1845,
    width: 35.1845
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    x: 317.31573,
    y: -232.65119,
    id: "svg_7",
    fill: "#435E64",
    transform: "matrix(-0.922336 0.264475 0.264475 0.922336 842.53 200.096)",
    rx: 17.5,
    height: 35,
    width: 200
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    x: 317.31573,
    y: -232.65119,
    id: "svg_8",
    fill: "#5D7C84",
    transform: "matrix(-0.922336 0.264475 0.264475 0.922336 712.302 236.762)",
    rx: 18,
    height: 36,
    width: 166
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    x: 317.31573,
    y: -232.65119,
    id: "svg_9",
    fill: "#86AAB4",
    transform: "matrix(-0.922336 0.264475 0.264475 0.922336 725.324 233.469)",
    rx: 17.5922,
    height: 35.1845,
    width: 35.1845
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInvoicesRight);
export default __webpack_public_path__ + "static/media/no-invoices-right.5b00ef35891be938cd1d64d09f14750e.svg";
export { ForwardRef as ReactComponent };